import { getTotalPricingDuration } from '@sequencehq/utils'
import {
  apiDatesAdapters,
  durationsToDateAdapter
} from '@sequencehq/utils/dates'
import isObject from 'lodash/fp/isObject'
import { CubeReducerState } from 'modules/Cube/domain/cube.domain.types'

type OriginalPhase = NonNullable<
  CubeReducerState['data']['quote']['amendment']
>['original']['phases'][number]

export const getContractDuration = (prevState: CubeReducerState) => {
  const isAmendment = prevState.data.quote.dealType === 'AMENDMENT'
  const originalPhases = prevState.data.quote.amendment?.original.phases ?? []

  if (isAmendment && originalPhases.length) {
    return getOriginalScheduleDuration(originalPhases)
  }

  return getPhasesDuration(prevState)
}

export const getPhasesDuration = (prevState: Pick<CubeReducerState, 'data'>) =>
  getTotalPricingDuration({
    startDate: prevState.data.common.startDate,
    // Non-object durations (OPEN_ENDED, MILESTONE) are open-ended
    phases: prevState.data.common.phaseIds.map(id => {
      const duration = prevState.data.phases[id].duration
      return { duration: isObject(duration) ? duration : undefined }
    })
  })

export const getOriginalScheduleDuration = (phases: OriginalPhase[]) => {
  const sortedPhases = [...phases].sort((a, b) =>
    a.startDate.localeCompare(b.startDate)
  )
  const scheduleStartDate = apiDatesAdapters.fromApi(
    sortedPhases.at(0)?.startDate ?? ''
  )
  const scheduleEndDate = apiDatesAdapters.fromApi(
    sortedPhases.at(-1)?.endDate ?? ''
  )

  return durationsToDateAdapter.toDuration(scheduleStartDate)(scheduleEndDate)
}
